import React from "react";
import { InputGroup, FormControl, Alert } from "react-bootstrap";

import { Footer } from "../components/include/Footer";
import Title from "../components/common/Title";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  isLoading,
  isError,
  isAuthenticated,
  isMessage,
  isData,
} from "../redux/selectors/authSelector";
import { otpVerify, verifyEmail } from "../redux/actions/authActions";
import { useLocation, useNavigate } from "react-router-dom";
import { message } from "../redux/actions/toastActions";
import emailIcon from "../assets/Icons/email.svg";
import leftIcon from "../assets/Icons/leftArrow.svg";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import Logo from "../assets/logo.jpg";
import "../styles/Login.scss";
import EmailVerification from "../components/common/EmailVerification";
import logoBg from "../assets/Icons/Frame 475.svg";
import loginBg from "../assets/pst-auth-bg.png";
import { useCountryNavigate } from "../components/common/UseCountryNavigate";


const Verification = () => {
  const [username, setusername] = useState(
    process.env.NODE_ENV !== "production" ? "devadmin" : ""
  );
  const [password, setpassword] = useState(
    process.env.NODE_ENV !== "production" ? "123456" : ""
  );
  const [showPassword, setShowPassword] = useState(false);
  const [remember, setremember] = useState(false);
  // const [IPAddress, setIPAddress] = useState('')
  const loader = useSelector(isLoading);
  const Authenticated = useSelector(isAuthenticated);
  const Data = useSelector(isData);
  const loginMessage = useSelector(isMessage);
  const errorMsg = useSelector(isError);
  const dispatch = useDispatch();
  // const navigate = useNavigate();
  const navigate = useCountryNavigate();
  const location = useLocation();
  const { data } = useSelector(
    (state) => state.auth // or use your reducer key name if different
  );

  console.log(data, "-------------------")

  const onVerifyAction = async (otp) => {
    // navigate("/reset-password");
    console.log("email =>", location.state?.email);
    console.log("otp =>", otp);
    dispatch(
      otpVerify({ email: location.state?.email || "", otp }, () => {
        navigate("reset-password", { state: { email: location.state?.email } }); // redirect after success
        dispatch(message(loginMessage));
      })
    );
  };

  const onResendAction = async (event) => {
    // event.preventDefault();
    dispatch(
      verifyEmail({ username: username, email: location.state?.email, password: password, remember: remember })
    );
  };

  return (
    <>
      <Title name="Verification" />
      {console.log("errorMsg => ddddddddddd", errorMsg)}
      <div
        className="account-pages"
        style={{ paddingTop: "13%" }}
      >
        <div className="account-pages">
          <img src={loginBg} className="login-background-img" alt="background" />
        </div>
        <div className="absolute top-8 right-8 w-80 h-auto z-10">
          <img src={logoBg} alt="App Logo" className="w-full h-auto" />
        </div>

        <div className="container ">
          <div className="row justify-content-start">
            <div className="col-md-8 col-lg-6 col-xl-5">
              {errorMsg && <Alert variant="info">{errorMsg}</Alert>}
              <div
                className="card overflow-hidden"
                style={{ backgroundColor: "white" }}
              >
                <EmailVerification
                  loader={loader}
                  onVerifyAction={onVerifyAction}
                  sentOTP={onResendAction}
                />
              </div>
              {/* <div className="mt-5 text-center">
                <Footer />
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Verification;
